// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Uploader-space1-Xo6nU {
	margin-bottom: 6px !important;
}

.Uploader-space2-YSA0d {
	margin-bottom: 12px !important;
}

.Uploader-space3-Zx0Q0 {
	margin-bottom: 18px !important;
}

.Uploader-space4-_7WNN {
	margin-bottom: 24px !important;
}

.Uploader-space5-EtiEA {
	margin-bottom: 30px !important;
}

.Uploader-space6-wQj_b {
	margin-bottom: 36px !important;
}

.Uploader-space7-i7Coa {
	margin-bottom: 42px !important;
}

.Uploader-spaceTop8-soNbO {
	margin-bottom: 48px !important;
}

.Uploader-spaceTop1-sw2zC {
	margin-top: 6px !important;
}

.Uploader-spaceTop2-AdS_F {
	margin-top: 12px !important;
}

.Uploader-spaceTop3-DfqrH {
	margin-top: 18px !important;
}

.Uploader-spaceTop4-Y1j0x {
	margin-top: 24px !important;
}

.Uploader-spaceTop5-GjbxH {
	margin-top: 30px !important;
}

.Uploader-spaceTop6-FLWhH {
	margin-top: 36px !important;
}

.Uploader-spaceTop7-txNNU {
	margin-top: 42px !important;
}

.Uploader-spaceTop8-soNbO {
	margin-top: 48px !important;
}

.Uploader-noMargin-G8b3Y {
	margin: 0px !important;
}

.Uploader-padding1-x01ZJ {
	padding-bottom: 6px !important;
}

.Uploader-padding2-f5fiO {
	padding-bottom: 12px !important;
}

.Uploader-padding3-uSOGp {
	padding-bottom: 18px !important;
}

.Uploader-padding4-e_T3R {
	padding-bottom: 24px !important;
}

.Uploader-padding5-kudfF {
	padding-bottom: 30px !important;
}

.Uploader-padding6-lOITf {
	padding-bottom: 36px !important;
}

.Uploader-padding7-gVJpl {
	padding-bottom: 42px !important;
}

.Uploader-paddingTop1-zt2hN {
	padding-top: 6px !important;
}

.Uploader-paddingTop2-UUZWo {
	padding-top: 12px !important;
}

.Uploader-paddingTop3-MfsF2 {
	padding-top: 18px !important;
}

.Uploader-paddingTop4-u3Vbf {
	padding-top: 24px !important;
}

.Uploader-paddingTop5-qYfmK {
	padding-top: 30px !important;
}

.Uploader-paddingTop6-r7juq {
	padding-top: 36px !important;
}

.Uploader-paddingTop7-YzZ5Z {
	padding-top: 42px !important;
}

.Uploader-noPadding-Xm3Y3 {
	padding: 0px !important;
}

.Uploader-textBold-YHG95 {
	font-weight: 500 !important;
}

.Uploader-textBolder-Ra3sK {
	font-weight: 700 !important;
}

.Uploader-textNormal-q9h4j {
	font-weight: normal !important;
}

.Uploader-spaceBottom20-h5Agu {
	margin-bottom: 20px;
}

.Uploader-spaceBottom10-ILeQv {
	margin-bottom: 10px;
}

.Uploader-marginNone-P3_CW {
	margin: 0;
}

.Uploader-spaceBottom15-HLWdF {
	margin-bottom: 15px;
}

.Uploader-marginTopNone-xj96b {
	margin-top: 0;
}

.Uploader-spaceTop11-PlPwi {
	margin-top: 11px;
}

.Uploader-spaceTop21-qv9cW {
	margin-top: 21px;
}

.Uploader-spaceTop20-zJioo {
	margin-top: 20px;
}

.Uploader-spaceTop10-LfL8N {
	margin-top: 10px;
}

/*New Design Text Colors */

.Uploader-textDarkBlue-HNq0e {
	color: rgb(20, 39, 94) !important;
}

.Uploader-textLightBlue-Sv52x {
	color: rgb(57, 87, 106) !important;
}

.Uploader-textLightSandleGreen-KDVap {
	color: rgb(76, 86, 41) !important;
}

.Uploader-textLightBrown-aKTb8 {
	color: rgb(115, 79, 33) !important;
}

.Uploader-textMediumMaroon-yc06j {
	color: rgb(87, 37, 51) !important;
}

.Uploader-textBrown-R_ECu {
	color: rgb(160, 47, 24) !important;
}

.Uploader-textMaroon-OOhJk {
	color: rgb(155, 49, 67) !important;
}

.Uploader-textDarkBrown-EkxfP {
	color: rgb(83, 18, 16) !important;
}

.Uploader-textMediumBrown-FQwTG {
	color: rgb(142, 28, 10) !important;
}

.Uploader-textSkyBlue-mOxMm {
	color: rgb(37, 117, 141) !important;
}

.Uploader-textGray-LnT5r {
	color: rgb(77, 65, 51) !important;
}

.Uploader-commonHeaderAdmin-y2KCN {
	position: fixed !important;
}

.Uploader-adminLayout-DLBMQ {
	padding-top: 64px !important;
}

.Uploader-box-IEB8_ h2 {
	font-size: 21px;
	font-weight: 600;
}

.Uploader-exportLink-OBfEV {
	margin-bottom: -29px;
}

.Uploader-blockCenter-j1NKl {
	float: none !important;
	display: block;
	margin: 0 auto;
	margin-top: 30px;
}

.Uploader-panelHeader-YB1RL {
	padding-bottom: 18px !important;
	padding: 24px 15px;
	border-radius: 6px !important;
	border: 1px solid var(--primary-border)
}

.Uploader-currencyselect-gfaDV {
	width: 100%;
	margin-right: 0px;
}

.Uploader-panelHeader-YB1RL {
	overflow: hidden;
	position: relative;
}

.Uploader-mar0-YKggO {
	margin-left: 0;
	margin-right: 0;
}

@media screen and (max-width: 767px) {
	.Uploader-blockCenter-j1NKl {
		padding: 0px;
	}

	.Uploader-panelHeader-YB1RL {
		padding: 24px 5px;
	}
}

/** Admin - Common - Start **/

.Uploader-sideAdminPageWrapper-f6fd3 {
	margin-left: var(--siteAdmin-sideBar-width);
	position: relative;
	padding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;
}

.Uploader-panelHeader-YB1RL {
	border-radius: 0;
	width: 100%;
	display: block;
	font-size: 16px;
	padding-bottom: 12px;
	border-bottom: 1px solid var(--primary-border);
	background-color: var(--background-primary);
}

.Uploader-table-oMJAH {
	display: table;
}

.Uploader-tableRow-ze_40 {
	display: table-row;
}

.Uploader-tableCell-P74Ow {
	display: table-cell;
	float: none;
}

.Uploader-formGroup-O0z0G {
	margin-bottom: 6px;
}

.Uploader-select-E1AH3 {
	position: relative;
	display: inline-block;
	vertical-align: bottom;
	margin-right: 5px;
}

.Uploader-noMargin-G8b3Y {
	margin: 0px;
}

a,
a:hover {
	cursor: pointer;
}

.Uploader-exportLink-OBfEV {
	padding-top: 10px;
	padding-right: 10px;
}

.Uploader-labelTextNew-ya_u5 {
	font-size: 16px;
	line-height: 24px;
	font-weight: 600;
	margin: 0 0 6px;
	text-align: start;
	color: var(--primary-foreground);
}

.Uploader-displayInline-YAJiv {
	display: inline-block;
}

/******************* Admin Modal ListSetting Start *******************/

.Uploader-btnUPdate-LpfIF {
	display: inline-block;
}

.Uploader-btnModalDelete-ksE1r {
	display: inline-block;
	margin-left: 15px;
}

.Uploader-radioBtn-ZEMv3 {
	position: relative;
	top: 1px;
	vertical-align: middle;
}

.Uploader-backgroundImg-m34Zx {
	padding-top: 80%;
	background-position: top center;
	background-size: cover;
}

@media screen and (max-width: 767px) {
	.Uploader-btnUPdate-LpfIF {
		display: block;
		margin-bottom: 12px;
	}

	.Uploader-btnModalDelete-ksE1r {
		display: block;
		margin-left: 0px;
	}

	.Uploader-btnWidth-LDImk {
		width: 100%;
	}
}

/******************* Admin Modal ListSetting Start *******************/

/******************* Admin Banner Image Section Start ****************/

.Uploader-bannerImageBg-WPgkv {
	padding-top: 60%;
	background-repeat: no-repeat;
	background-size: contain;
	border-radius: 4px;
	background-position: center;
	background-color: var(--secondary-gray-bg);
	border: 1px dashed var(--primary-border);
}

.Uploader-bannerDelete-kNTye {
	position: absolute;
	top: -12px;
	right: 4px;
}

/*******************Admin Modal Start **********************/

.Uploader-modalRoot-TCPG2 {
	padding: 32px;
}

.Uploader-modalBorderBottom-EiRX5 {
	border-bottom: 5px solid var(--primary-bg);
	border-bottom-left-radius: 14px;
	border-bottom-right-radius: 14px;
}

.Uploader-logInModalBody-CDSVp {
	padding: 0px;
}

/*************** Admin TableNew Design Start**************************/

.Uploader-exportSection-EJhc6 {
	background: #f5f5f5;
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border-top-left-radius: 6px;
	border-top-right-radius: 6px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
}

.Uploader-exportSectionGridSub-aHBpR {
	grid-template-columns: 50% 49% !important;
}

.Uploader-exportText-nA1PZ {
	color: var(--primary-foreground) !important;
	text-decoration: none !important;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 12px;
}

.Uploader-exportLinkImg-EQH8w {
	background: var(--common-white-primary-bg);
	padding: 10px;
	border-radius: 4px;
	display: inline-block;
}

.Uploader-vtrMiddle-wh7Ja {
	vertical-align: middle;
}

.Uploader-exportImg-SUI8I {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.Uploader-profileViewlabel-WQoz0 {
	display: inline-block;
	width: 38%
}

.Uploader-profileViewMainContent-AyOhW {
	display: inline-block;
	width: 62%;
}

.Uploader-profileViewMain-PVhLa {
	border: 1px solid var(--primary-border);
	border-radius: 6px;
}

.Uploader-profileViewInner-nqDif {
	padding: 10px;
	border-bottom: 1px solid var(--primary-border);
}

.Uploader-profileImageSection-WxBpu {
	width: 100%;
	height: 100px;
	max-width: 100px;
	max-height: 100px;
	border-radius: 50%;
}

.Uploader-lastviewInner-XfJve {
	padding: 10px;
}

.Uploader-whyHostHoriLine-KF2MI {
	margin: 30px 0;
}

.Uploader-tableGrid-uZzAd {
	display: grid;
	grid-template-columns: 50% 50%;
	-webkit-column-gap: 10px;
	   -moz-column-gap: 10px;
	        column-gap: 10px;
	word-wrap: break-word;
}

.Uploader-headingContent-I9LiH {
	font-size: 18px;
	font-weight: 500;
}

.Uploader-refundTextColor-NDB0L {
	color: var(--alert-color);
	font-size: 18px;
	text-decoration: line-through;
	text-decoration-thickness: 2px;
	text-decoration-color: var(--black-color);
}

.Uploader-dividerLine-stJwg {
	border-top: 1px solid var(--primary-border);
	margin: 30px 0;
}

.Uploader-smallContent-j8TOF {
	font-size: 14px;
	margin-top: 6px;
	color: var(--secondary-foreground);
}

@media (max-width: 1200px) and (min-width: 1024px) {
	.Uploader-sideAdminPageWrapper-f6fd3 {
		height: 100%;
		overflow: auto;
	}
}

@media (max-width:1199px) {
	.Uploader-sideAdminPageWrapper-f6fd3 {
		margin-left: 0;
	}
}

@media screen and (max-width: 991px) {
	.Uploader-exportSection-EJhc6 {
		grid-template-columns: 100%;
	}

	.Uploader-exportSectionGridSub-aHBpR {
		grid-template-columns: 100% !important;
	}

}

@media screen and (max-width: 767px) {
	.Uploader-profileViewlabel-WQoz0 {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.Uploader-profileViewMainContent-AyOhW {
		width: 100%;
		text-align: center;
	}
}

/*************** Admin TableNew Design End**************************/

.Uploader-ChangeToUpperCase-Dvs5r {
	text-transform: uppercase
}

.Uploader-noBorder-vNkoZ {
	border: 0px !important;
}

/** Admin - Common - End **/

/* site Admin utility Start */

.Uploader-siteAdminHeading-Vnp0h {
	font-size: 24px;
	line-height: 32px;
	font-weight: 700;
	margin: 0 0 24px;
	text-align: start;
	color: var(--primary-foreground);
}

.Uploader-siteAdminSubHeading-FV8Lb {
	font-size: 18px;
	line-height: 26px;
	font-weight: 600;
	margin: 0 0 12px;
	text-align: start;
	color: var(--primary-foreground);
}

.Uploader-adminFormDivider-HUIjW {
	border-top: 1px solid var(--primary-border);
	margin-bottom: 24px;
}`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/siteadmin/newcommonstyle.css","webpack://./src/components/siteadmin/admin-common.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC5NA;CACC,0BAA0B;AAC3B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,sBAAsB;CACtB,cAAc;CACd,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,+BAA+B;CAC/B,kBAAkB;CAClB,6BAA6B;CAC7B;AACD;;AAEA;CACC,WAAW;CACX,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC;EACC,YAAY;CACb;;CAEA;EACC,iBAAiB;CAClB;AACD;;ACpDA,6BAA6B;;AAC7B;CACC,2CAA2C;CAC3C,kBAAkB;CAClB,+DAA+D;AAChE;;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,cAAc;CACd,eAAe;CACf,oBAAoB;CACpB,8CAA8C;CAC9C,2CAA2C;AAC5C;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,sBAAsB;CACtB,iBAAiB;AAClB;;AAEA;CACC,WAAW;AACZ;;AAEA;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,qBAAqB;AACtB;;AAEA,sEAAsE;;AAEtE;CACC,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;CACrB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,sBAAsB;AACvB;;AAEA;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,sBAAsB;AACvB;;AAEA;CACC;EACC,cAAc;EACd,mBAAmB;CACpB;;CAEA;EACC,cAAc;EACd,gBAAgB;CACjB;;CAEA;EACC,WAAW;CACZ;AACD;;AAEA,sEAAsE;;AAEtE,sEAAsE;;AAEtE;CACC,gBAAgB;CAChB,4BAA4B;CAC5B,wBAAwB;CACxB,kBAAkB;CAClB,2BAA2B;CAC3B,0CAA0C;CAC1C,wCAAwC;AACzC;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,UAAU;AACX;;AAEA,4DAA4D;;AAE5D;CACC,aAAa;AACd;;AAEA;CACC,0CAA0C;CAC1C,+BAA+B;CAC/B,gCAAgC;AACjC;;AAEA;CACC,YAAY;AACb;;AAEA,sEAAsE;;AAEtE;CACC,mBAAmB;CACnB,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,2BAA2B;CAC3B,4BAA4B;CAC5B,uCAAuC;CACvC,gBAAgB;AACjB;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,gCAAgC;CAChC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,0CAA0C;CAC1C,aAAa;CACb,kBAAkB;CAClB,qBAAqB;AACtB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB;AACD;;AAEA;CACC,qBAAqB;CACrB,UAAU;AACX;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,8CAA8C;AAC/C;;AAEA;CACC,WAAW;CACX,aAAa;CACb,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,wBAAgB;IAAhB,qBAAgB;SAAhB,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,eAAe;CACf,6BAA6B;CAC7B,8BAA8B;CAC9B,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,cAAc;AACf;;AAEA;CACC,eAAe;CACf,eAAe;CACf,kCAAkC;AACnC;;AAEA;CACC;EACC,YAAY;EACZ,cAAc;CACf;AACD;;AAEA;CACC;EACC,cAAc;CACf;AACD;;AAEA;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,sCAAsC;CACvC;;AAED;;AAEA;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;AACD;;AAEA,oEAAoE;;AAEpE;CACC;AACD;;AAEA;CACC,sBAAsB;AACvB;;AAEA,2BAA2B;;AAE3B,6BAA6B;;AAC7B;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,2CAA2C;CAC3C,mBAAmB;AACpB","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}",".commonHeaderAdmin {\n\tposition: fixed !important;\n}\n\n.adminLayout {\n\tpadding-top: 64px !important;\n}\n\n.box h2 {\n\tfont-size: 21px;\n\tfont-weight: 600;\n}\n\n.exportLink {\n\tmargin-bottom: -29px;\n}\n\n.blockCenter {\n\tfloat: none !important;\n\tdisplay: block;\n\tmargin: 0 auto;\n\tmargin-top: 30px;\n}\n\n.panelHeader {\n\tpadding-bottom: 18px !important;\n\tpadding: 24px 15px;\n\tborder-radius: 6px !important;\n\tborder: 1px solid var(--primary-border)\n}\n\n.currencyselect {\n\twidth: 100%;\n\tmargin-right: 0px;\n}\n\n.panelHeader {\n\toverflow: hidden;\n\tposition: relative;\n}\n\n.mar0 {\n\tmargin-left: 0;\n\tmargin-right: 0;\n}\n\n@media screen and (max-width: 767px) {\n\t.blockCenter {\n\t\tpadding: 0px;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 24px 5px;\n\t}\n}","@import './newcommonstyle.css';\n\n/** Admin - Common - Start **/\n.sideAdminPageWrapper {\n\tmargin-left: var(--siteAdmin-sideBar-width);\n\tposition: relative;\n\tpadding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;\n}\n\n.panelHeader {\n\tborder-radius: 0;\n\twidth: 100%;\n\tdisplay: block;\n\tfont-size: 16px;\n\tpadding-bottom: 12px;\n\tborder-bottom: 1px solid var(--primary-border);\n\tbackground-color: var(--background-primary);\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.select {\n\tposition: relative;\n\tdisplay: inline-block;\n\tvertical-align: bottom;\n\tmargin-right: 5px;\n}\n\n.noMargin {\n\tmargin: 0px;\n}\n\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.labelTextNew {\n\tfont-size: 16px;\n\tline-height: 24px;\n\tfont-weight: 600;\n\tmargin: 0 0 6px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.displayInline {\n\tdisplay: inline-block;\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n.btnUPdate {\n\tdisplay: inline-block;\n}\n\n.btnModalDelete {\n\tdisplay: inline-block;\n\tmargin-left: 15px;\n}\n\n.radioBtn {\n\tposition: relative;\n\ttop: 1px;\n\tvertical-align: middle;\n}\n\n.backgroundImg {\n\tpadding-top: 80%;\n\tbackground-position: top center;\n\tbackground-size: cover;\n}\n\n@media screen and (max-width: 767px) {\n\t.btnUPdate {\n\t\tdisplay: block;\n\t\tmargin-bottom: 12px;\n\t}\n\n\t.btnModalDelete {\n\t\tdisplay: block;\n\t\tmargin-left: 0px;\n\t}\n\n\t.btnWidth {\n\t\twidth: 100%;\n\t}\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n/******************* Admin Banner Image Section Start ****************/\n\n.bannerImageBg {\n\tpadding-top: 60%;\n\tbackground-repeat: no-repeat;\n\tbackground-size: contain;\n\tborder-radius: 4px;\n\tbackground-position: center;\n\tbackground-color: var(--secondary-gray-bg);\n\tborder: 1px dashed var(--primary-border);\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: -12px;\n\tright: 4px;\n}\n\n/*******************Admin Modal Start **********************/\n\n.modalRoot {\n\tpadding: 32px;\n}\n\n.modalBorderBottom {\n\tborder-bottom: 5px solid var(--primary-bg);\n\tborder-bottom-left-radius: 14px;\n\tborder-bottom-right-radius: 14px;\n}\n\n.logInModalBody {\n\tpadding: 0px;\n}\n\n/*************** Admin TableNew Design Start**************************/\n\n.exportSection {\n\tbackground: #f5f5f5;\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder-top-left-radius: 6px;\n\tborder-top-right-radius: 6px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--primary-foreground) !important;\n\ttext-decoration: none !important;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 12px;\n}\n\n.exportLinkImg {\n\tbackground: var(--common-white-primary-bg);\n\tpadding: 10px;\n\tborder-radius: 4px;\n\tdisplay: inline-block;\n}\n\n.vtrMiddle {\n\tvertical-align: middle;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 6px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-bottom: 1px solid var(--primary-border);\n}\n\n.profileImageSection {\n\twidth: 100%;\n\theight: 100px;\n\tmax-width: 100px;\n\tmax-height: 100px;\n\tborder-radius: 50%;\n}\n\n.lastviewInner {\n\tpadding: 10px;\n}\n\n.whyHostHoriLine {\n\tmargin: 30px 0;\n}\n\n.tableGrid {\n\tdisplay: grid;\n\tgrid-template-columns: 50% 50%;\n\tcolumn-gap: 10px;\n\tword-wrap: break-word;\n}\n\n.headingContent {\n\tfont-size: 18px;\n\tfont-weight: 500;\n}\n\n.refundTextColor {\n\tcolor: var(--alert-color);\n\tfont-size: 18px;\n\ttext-decoration: line-through;\n\ttext-decoration-thickness: 2px;\n\ttext-decoration-color: var(--black-color);\n}\n\n.dividerLine {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin: 30px 0;\n}\n\n.smallContent {\n\tfont-size: 14px;\n\tmargin-top: 6px;\n\tcolor: var(--secondary-foreground);\n}\n\n@media (max-width: 1200px) and (min-width: 1024px) {\n\t.sideAdminPageWrapper {\n\t\theight: 100%;\n\t\toverflow: auto;\n\t}\n}\n\n@media (max-width:1199px) {\n\t.sideAdminPageWrapper {\n\t\tmargin-left: 0;\n\t}\n}\n\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n\n}\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n}\n\n/*************** Admin TableNew Design End**************************/\n\n.ChangeToUpperCase {\n\ttext-transform: uppercase\n}\n\n.noBorder {\n\tborder: 0px !important;\n}\n\n/** Admin - Common - End **/\n\n/* site Admin utility Start */\n.siteAdminHeading {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 700;\n\tmargin: 0 0 24px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.siteAdminSubHeading {\n\tfont-size: 18px;\n\tline-height: 26px;\n\tfont-weight: 600;\n\tmargin: 0 0 12px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.adminFormDivider {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin-bottom: 24px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `Uploader-space1-Xo6nU`,
	"space2": `Uploader-space2-YSA0d`,
	"space3": `Uploader-space3-Zx0Q0`,
	"space4": `Uploader-space4-_7WNN`,
	"space5": `Uploader-space5-EtiEA`,
	"space6": `Uploader-space6-wQj_b`,
	"space7": `Uploader-space7-i7Coa`,
	"spaceTop8": `Uploader-spaceTop8-soNbO`,
	"spaceTop1": `Uploader-spaceTop1-sw2zC`,
	"spaceTop2": `Uploader-spaceTop2-AdS_F`,
	"spaceTop3": `Uploader-spaceTop3-DfqrH`,
	"spaceTop4": `Uploader-spaceTop4-Y1j0x`,
	"spaceTop5": `Uploader-spaceTop5-GjbxH`,
	"spaceTop6": `Uploader-spaceTop6-FLWhH`,
	"spaceTop7": `Uploader-spaceTop7-txNNU`,
	"noMargin": `Uploader-noMargin-G8b3Y`,
	"padding1": `Uploader-padding1-x01ZJ`,
	"padding2": `Uploader-padding2-f5fiO`,
	"padding3": `Uploader-padding3-uSOGp`,
	"padding4": `Uploader-padding4-e_T3R`,
	"padding5": `Uploader-padding5-kudfF`,
	"padding6": `Uploader-padding6-lOITf`,
	"padding7": `Uploader-padding7-gVJpl`,
	"paddingTop1": `Uploader-paddingTop1-zt2hN`,
	"paddingTop2": `Uploader-paddingTop2-UUZWo`,
	"paddingTop3": `Uploader-paddingTop3-MfsF2`,
	"paddingTop4": `Uploader-paddingTop4-u3Vbf`,
	"paddingTop5": `Uploader-paddingTop5-qYfmK`,
	"paddingTop6": `Uploader-paddingTop6-r7juq`,
	"paddingTop7": `Uploader-paddingTop7-YzZ5Z`,
	"noPadding": `Uploader-noPadding-Xm3Y3`,
	"textBold": `Uploader-textBold-YHG95`,
	"textBolder": `Uploader-textBolder-Ra3sK`,
	"textNormal": `Uploader-textNormal-q9h4j`,
	"spaceBottom20": `Uploader-spaceBottom20-h5Agu`,
	"spaceBottom10": `Uploader-spaceBottom10-ILeQv`,
	"marginNone": `Uploader-marginNone-P3_CW`,
	"spaceBottom15": `Uploader-spaceBottom15-HLWdF`,
	"marginTopNone": `Uploader-marginTopNone-xj96b`,
	"spaceTop11": `Uploader-spaceTop11-PlPwi`,
	"spaceTop21": `Uploader-spaceTop21-qv9cW`,
	"spaceTop20": `Uploader-spaceTop20-zJioo`,
	"spaceTop10": `Uploader-spaceTop10-LfL8N`,
	"textDarkBlue": `Uploader-textDarkBlue-HNq0e`,
	"textLightBlue": `Uploader-textLightBlue-Sv52x`,
	"textLightSandleGreen": `Uploader-textLightSandleGreen-KDVap`,
	"textLightBrown": `Uploader-textLightBrown-aKTb8`,
	"textMediumMaroon": `Uploader-textMediumMaroon-yc06j`,
	"textBrown": `Uploader-textBrown-R_ECu`,
	"textMaroon": `Uploader-textMaroon-OOhJk`,
	"textDarkBrown": `Uploader-textDarkBrown-EkxfP`,
	"textMediumBrown": `Uploader-textMediumBrown-FQwTG`,
	"textSkyBlue": `Uploader-textSkyBlue-mOxMm`,
	"textGray": `Uploader-textGray-LnT5r`,
	"commonHeaderAdmin": `Uploader-commonHeaderAdmin-y2KCN`,
	"adminLayout": `Uploader-adminLayout-DLBMQ`,
	"box": `Uploader-box-IEB8_`,
	"exportLink": `Uploader-exportLink-OBfEV`,
	"blockCenter": `Uploader-blockCenter-j1NKl`,
	"panelHeader": `Uploader-panelHeader-YB1RL`,
	"currencyselect": `Uploader-currencyselect-gfaDV`,
	"mar0": `Uploader-mar0-YKggO`,
	"sideAdminPageWrapper": `Uploader-sideAdminPageWrapper-f6fd3`,
	"table": `Uploader-table-oMJAH`,
	"tableRow": `Uploader-tableRow-ze_40`,
	"tableCell": `Uploader-tableCell-P74Ow`,
	"formGroup": `Uploader-formGroup-O0z0G`,
	"select": `Uploader-select-E1AH3`,
	"labelTextNew": `Uploader-labelTextNew-ya_u5`,
	"displayInline": `Uploader-displayInline-YAJiv`,
	"btnUPdate": `Uploader-btnUPdate-LpfIF`,
	"btnModalDelete": `Uploader-btnModalDelete-ksE1r`,
	"radioBtn": `Uploader-radioBtn-ZEMv3`,
	"backgroundImg": `Uploader-backgroundImg-m34Zx`,
	"btnWidth": `Uploader-btnWidth-LDImk`,
	"bannerImageBg": `Uploader-bannerImageBg-WPgkv`,
	"bannerDelete": `Uploader-bannerDelete-kNTye`,
	"modalRoot": `Uploader-modalRoot-TCPG2`,
	"modalBorderBottom": `Uploader-modalBorderBottom-EiRX5`,
	"logInModalBody": `Uploader-logInModalBody-CDSVp`,
	"exportSection": `Uploader-exportSection-EJhc6`,
	"exportSectionGridSub": `Uploader-exportSectionGridSub-aHBpR`,
	"exportText": `Uploader-exportText-nA1PZ`,
	"exportLinkImg": `Uploader-exportLinkImg-EQH8w`,
	"vtrMiddle": `Uploader-vtrMiddle-wh7Ja`,
	"exportImg": `Uploader-exportImg-SUI8I`,
	"profileViewlabel": `Uploader-profileViewlabel-WQoz0`,
	"profileViewMainContent": `Uploader-profileViewMainContent-AyOhW`,
	"profileViewMain": `Uploader-profileViewMain-PVhLa`,
	"profileViewInner": `Uploader-profileViewInner-nqDif`,
	"profileImageSection": `Uploader-profileImageSection-WxBpu`,
	"lastviewInner": `Uploader-lastviewInner-XfJve`,
	"whyHostHoriLine": `Uploader-whyHostHoriLine-KF2MI`,
	"tableGrid": `Uploader-tableGrid-uZzAd`,
	"headingContent": `Uploader-headingContent-I9LiH`,
	"refundTextColor": `Uploader-refundTextColor-NDB0L`,
	"dividerLine": `Uploader-dividerLine-stJwg`,
	"smallContent": `Uploader-smallContent-j8TOF`,
	"ChangeToUpperCase": `Uploader-ChangeToUpperCase-Dvs5r`,
	"noBorder": `Uploader-noBorder-vNkoZ`,
	"siteAdminHeading": `Uploader-siteAdminHeading-Vnp0h`,
	"siteAdminSubHeading": `Uploader-siteAdminSubHeading-FV8Lb`,
	"adminFormDivider": `Uploader-adminFormDivider-HUIjW`
};
module.exports = ___CSS_LOADER_EXPORT___;
